import Vuetify from '../../plugins/vuetify';
export default {
  /**
   * Main Toast
   */
  setShowLoading: function setShowLoading(state, value) {
    state.showLoading = value;
  },
  setShowMessage: function setShowMessage(state, value) {
    state.showMessage = value;
  },
  setValue: function setValue(state, value) {
    state.value = value;
  },
  setToastMessage: function setToastMessage(state, value) {
    state.toastMessage = value;
  },
  setNewAudience: function setNewAudience(state, value) {
    state.newAudience = value;
  },
  showToast: function showToast(state, toast) {
    var color = toast.color,
      timeout = toast.timeout,
      message = toast.message;
    state.toast = {
      message: message,
      color: color,
      timeout: timeout,
      show: true
    };
  },
  hideToast: function hideToast(state) {
    state.toast.show = false;
  },
  resetToast: function resetToast(state) {
    state.toast = {
      show: false,
      color: 'black',
      message: '',
      timeout: 3000
    };
  },
  /**
   * Theme and Layout
   */
  setGlobalTheme: function setGlobalTheme(state, theme) {
    Vuetify.framework.theme.dark = theme === 'dark';
    state.globalTheme = theme;
  },
  setRTL: function setRTL(state, isRTL) {
    Vuetify.framework.rtl = isRTL;
    state.isRTL = isRTL;
  },
  setContentBoxed: function setContentBoxed(state, isBoxed) {
    state.isContentBoxed = isBoxed;
  },
  setMenuTheme: function setMenuTheme(state, theme) {
    state.menuTheme = theme;
  },
  setToolbarTheme: function setToolbarTheme(state, theme) {
    state.toolbarTheme = theme;
  },
  setTimeZone: function setTimeZone(state, zone) {
    state.time.zone = zone;
  },
  setTimeFormat: function setTimeFormat(state, format) {
    state.time.format = format;
  },
  setCurrency: function setCurrency(state, currency) {
    state.currency = currency;
  },
  setToolbarDetached: function setToolbarDetached(state, isDetached) {
    state.isToolbarDetached = isDetached;
  },
  setMenuSelected: function setMenuSelected(state, value) {
    state.menuSelected = value;
  }
};